<div class="col full-height layout-row gap-5"
     [ngClass]="{'selected': isSelected}">

  <div class="flex layout-row layout-wrap info-container">

    <!--Link Row-->
    <div class="flex-100 layout-row layout-align-start-center service-title gap-5">
      <app-bringoz-checkbox [isChecked]="isSelected"
                            (clickEvent)="onToggleEvent($event)">
      </app-bringoz-checkbox>

      <span class="flex br-body-1 text-ellipsis">
        {{ 'Resource' | translate }} {{ resource.resourceAllocation.name }}
      </span>

      <bringoz-button *ngIf="canClose"
                      type="tertiary"
                      [ngbTooltip]="'Back'"
                      (onClick)="onClose.emit()">
        <bringoz-icon iconName="arrow-left" classSize="lg" fill="#484848"></bringoz-icon>
      </bringoz-button>

<!--      <app-bringoz-status-tag [status]="service.status"-->
<!--                              [extraTooltipText]="service?.cancellationReason?.reason"-->
<!--                              [isSmall]="true"-->
<!--                              class="margin-right-5">-->

<!--      </app-bringoz-status-tag>-->

<!--      <app-service-link [serviceType]="service.serviceType"-->
<!--                        [id]="service.id"-->
<!--                        [externalId]="service.externalId"-->
<!--                        isAllowCopyButton="true">-->
<!--      </app-service-link>-->

<!--      <app-service-type-indication [serviceType]="service.serviceType"-->
<!--                                   [isShort]="true">-->

<!--      </app-service-type-indication>-->

<!--      <app-oms-order-link *ngIf="service.omsOrderReference?.id"-->
<!--                          [internalId]="service.omsOrderReference?.id"-->
<!--                          [externalId]="service.omsOrderReference?.externalId">-->
<!--      </app-oms-order-link>-->

    </div>

    <!--Time Window Row-->
    <div *ngIf="settings?.columns?.timeWindow"
         class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="time-window-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'ROUTES_VIEW_RESOURCES_SETTINGS.timeWindow' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.schedule | timeWindow }}</span>
    </div>


    <!--Total Duration Row-->
    <div *ngIf="settings?.columns?.totalDuration"
         class="flex-100 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="timer-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'ROUTES_VIEW_RESOURCES_SETTINGS.totalDuration' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis"> {{ totalDuration | bringozTimeConvert }}</span>
    </div>

    <!--Tags Row-->
    <div *ngIf="settings?.columns?.tags"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="tag-outline"
                    classSize="md"
                    fill="#484848"
                    [ngbTooltip]="'ROUTES_VIEW_RESOURCES_SETTINGS.tags' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-tags *ngIf="resource.resourceAllocation.tags?.length"
                        class="margin-left-5"
                        [maxTags]="1"
                        [tags]="resource.resourceAllocation.tags">
      </app-bringoz-tags>
      <span *ngIf="!resource.resourceAllocation.tags?.length" class="br-body-1 text-ellipsis">---</span>
    </div>

    <!--Labels Row-->
    <div *ngIf="settings?.columns?.labels"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="label-outline"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'ROUTES_VIEW_RESOURCES_SETTINGS.labels' | translate"
                    openDelay="300">

      </bringoz-icon>
      <app-bringoz-labels-display *ngIf="!!resource.resourceAllocation.labels?.length"
                                  [labels]="resource.resourceAllocation.labels"
                                  maxItems="1">

      </app-bringoz-labels-display>
      <span *ngIf="!resource.resourceAllocation.labels?.length" class="br-body-1 text-ellipsis">---</span>
    </div>

    <!--Routes Count-->
    <div *ngIf="settings?.columns?.routesCount"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="route"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'ROUTES_VIEW_RESOURCES_SETTINGS.routesCount' | translate"
                    openDelay="300">
      </bringoz-icon>
      <span class="br-body-2">
        {{ (resource.scheduleExtraData?.routesCount === 1 ? 'X_ROUTE' : 'X_ROUTES') | translate: { sum: (resource.scheduleExtraData?.routesCount || 0) } }}
      </span>
    </div>

    <!--Route Names-->
    <div *ngIf="settings?.columns?.routeNames"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="hash"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'ROUTES_VIEW_RESOURCES_SETTINGS.routeNames' | translate"
                    openDelay="300">
      </bringoz-icon>
      <app-bringoz-items-list-display *ngIf="resource.routes?.length"
                                      class="flex"
                                      [items]="routeNames"
                                      [maxItems]="1">
      </app-bringoz-items-list-display>
      <span *ngIf="!resource.routes?.length" class="br-body-1 text-ellipsis">---</span>
    </div>

    <!--Retrips Names-->
    <div *ngIf="settings?.columns?.retrips"
         class="flex-50 layout-row layout-align-start-center info-row gap-5">
      <bringoz-icon iconName="return"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'ROUTES_VIEW_RESOURCES_SETTINGS.retrips' | translate"
                    openDelay="300">
      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ (resource.resourceAllocation.disableRetrips ? 'No' : 'Yes') | translate }}</span>
    </div>


    <!--Vehicle Type Row-->
    <div *ngIf="settings.columns.vehicleType"
         class="flex-50 layout-row layout-align-start-center info-row text-ellipsis gap-5 ">
      <bringoz-icon [iconName]="resource.resourceAllocation.vehicle?.type?.toLowerCase() || 'truck'"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'ROUTES_VIEW_RESOURCES_SETTINGS.vehicleType' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.resourceAllocation.vehicle?.name || '---' }}</span>
    </div>


    <!--Logistic Vehicles Row-->
    <div *ngIf="settings?.columns?.logisticVehicles"
         class="flex-100 layout-row info-row gap-5">

      <!--Main Logistic Vehicle-->
      <div class="flex layout-row layout-align-start-center text-ellipsis gap-5">
        <bringoz-icon [iconName]="resource.resourceAllocation.mainLogisticsVehicleReference?.vehicleType?.toLowerCase() || 'truck'"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Logistic Vehicle' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ resource.resourceAllocation.mainLogisticsVehicleReference?.name || '---' }}</span>
      </div>

      <!--Attached Logistic Vehicle-->
      <div *ngFor="let vehicle of resource.resourceAllocation.attachedLogisticsVehicleReferences;"
           class="flex layout-row layout-align-start-center text-ellipsis gap-5">
        <bringoz-icon [iconName]="vehicle.vehicleType?.toLowerCase() || 'Trailer'"
                      classSize="sm"
                      fill="#484848"
                      [ngbTooltip]="'Attached Logistic Vehicle' | translate"
                      openDelay="300">

        </bringoz-icon>
        <span class="br-body-1 text-ellipsis">{{ vehicle.name || '---' }}</span>
      </div>

    </div>


    <!--Load - Weight-->
    <div *ngIf="settings?.load?.weight"
         class="flex-50 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="weight"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Weight' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.capacity?.weight | bringozWeight:true:'---' }}</span>
    </div>

    <!--Load - Volume-->
    <div *ngIf="settings?.load?.volume"
         class="flex-50 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="volume"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Volume' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.capacity?.dimensions?.cube | bringozVolume: false:'---' }}</span>
    </div>

    <!--Load - Packages-->
    <div *ngIf="settings?.load?.packages"
         class="flex-50 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="package-outline"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Packages' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.capacity?.numberOfPackages || '---' }}</span>
    </div>

    <!--Load - Spots-->
    <div *ngIf="settings?.load?.spots"
         class="flex-50 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="spot"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Spots' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.capacity?.numberOfSpots || '---' }}</span>
    </div>

    <!--Load - Pallets-->
    <div *ngIf="settings?.load?.pallets"
         class="flex-50 layout-row layout-align-start-center info-row gap-5 text-ellipsis">
      <bringoz-icon iconName="pallets"
                    classSize="sm"
                    fill="#484848"
                    [ngbTooltip]="'Pallets' | translate"
                    openDelay="300">

      </bringoz-icon>
      <span class="br-body-1 text-ellipsis">{{ resource.capacity?.numberOfPallets || '---' }}</span>
    </div>

    <!--      &lt;!&ndash;Load - Value&ndash;&gt;-->
    <!--      <div *ngIf="settings?.load?.value"-->
    <!--           class="flex-25 layout-row layout-align-start-center info-row gap-5 text-ellipsis">-->
    <!--        <bringoz-icon iconName="dollar-circle"-->
    <!--                      classSize="sm"-->
    <!--                      fill="#484848"-->
    <!--                      [ngbTooltip]="'Value' | translate"-->
    <!--                      openDelay="300">-->

    <!--        </bringoz-icon>-->
    <!--        <span class="br-body-2 route-total-income"-->
    <!--              [ngClass]="getTotalIncomeClass(route?.totals?.totalIncome)">{{ route?.totals?.totalIncome | bringozPrice: '-&#45;&#45;' }}</span>-->
    <!--      </div>-->

    <!--      &lt;!&ndash;Capacity Row&ndash;&gt;-->
    <!--      <div-->
    <!--        *ngIf="settings.capacity?.weight || settings.capacity?.volume || settings.capacity?.packages || settings.capacity?.spots"-->
    <!--        [ngClass]="itemElementSize === 'medium' ? 'flex-25' : 'flex-50'"-->
    <!--        class=" layout-row layout-align-start-center info-row gap-5 ">-->
    <!--        <bringoz-icon iconName="packages"-->
    <!--                      classSize="sm"-->
    <!--                      fill="#484848"-->
    <!--                      [ngbTooltip]="'Capacity' | translate"-->
    <!--                      openDelay="300">-->

    <!--        </bringoz-icon>-->
    <!--        <app-bringoz-primary-capacity class="flex"-->
    <!--                                      [weightEnabled]="settings.capacity?.weight"-->
    <!--                                      [volumeEnabled]="settings.capacity?.volume"-->
    <!--                                      [packagesEnabled]="settings.capacity?.packages"-->
    <!--                                      [spotsEnabled]="settings.capacity?.spots"-->
    <!--                                      [weight]="route?.totals?.totalLoad"-->
    <!--                                      [maxWeight]="resource?.capacity?.weight"-->
    <!--                                      [volume]="route?.totals?.totalVolume"-->
    <!--                                      [maxDimensions]="resource?.capacity?.dimensions"-->
    <!--                                      [packages]="route?.totals?.totalPackagesCount"-->
    <!--                                      [maxPackages]="resource?.capacity?.numberOfPackages"-->
    <!--                                      [spots]="route?.totals?.totalSpots"-->
    <!--                                      [maxSpots]="resource?.capacity?.numberOfSpots">-->

    <!--        </app-bringoz-primary-capacity>-->


    <!--        &lt;!&ndash;      <bringoz-icon [iconName]="capacity.icon"&ndash;&gt;-->
    <!--        &lt;!&ndash;                    classSize="sm"&ndash;&gt;-->
    <!--        &lt;!&ndash;                    fill="#484848"&ndash;&gt;-->
    <!--        &lt;!&ndash;                    [ngbTooltip]="capacity.type | translate"&ndash;&gt;-->
    <!--        &lt;!&ndash;                    openDelay="300">&ndash;&gt;-->

    <!--        &lt;!&ndash;      </bringoz-icon>&ndash;&gt;-->
    <!--        &lt;!&ndash;      <app-bringoz-capacity-bar class="flex"&ndash;&gt;-->
    <!--        &lt;!&ndash;                                [value]="capacity.percentage"&ndash;&gt;-->
    <!--        &lt;!&ndash;                                [ngbTooltip]="capacityTooltip"&ndash;&gt;-->
    <!--        &lt;!&ndash;                                openDelay="300">&ndash;&gt;-->

    <!--        &lt;!&ndash;      </app-bringoz-capacity-bar>&ndash;&gt;-->
    <!--        &lt;!&ndash;      <span class="br-body-1">{{capacity.percentage}}%</span>&ndash;&gt;-->

    <!--        &lt;!&ndash;      <ng-template #capacityTooltip>&ndash;&gt;-->
    <!--        &lt;!&ndash;        <div class="layout-row layout-align-start-center gap-5">&ndash;&gt;-->
    <!--        &lt;!&ndash;          <span class="br-body-1">{{capacity.type | translate}}:</span>&ndash;&gt;-->
    <!--        &lt;!&ndash;          <span class="br-body-1">{{capacity.value}}/{{capacity.maxValue}}</span>&ndash;&gt;-->
    <!--        &lt;!&ndash;        </div>&ndash;&gt;-->
    <!--        &lt;!&ndash;      </ng-template>&ndash;&gt;-->

    <!--      </div>-->


  </div>

</div>
